module.exports = __webpack_public_path__ + "static/img/mini_code.3d33833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mini_code.png
// module id = FgUG
// module chunks = 1